import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { OrderFreteService } from '../../core/services/order-frete/order-frete.service';
import { ClienteService } from '../../core/services/clientes/cliente.service';

@Component({
    selector: 'app-cadastro-frete',
    templateUrl: './cadastro-frete.component.html',
    styleUrls: ['./cadastro-frete.component.css'],
    preserveWhitespaces: false,
    standalone: false
})
export class CadastroFreteComponent implements OnInit {

  is_master: boolean = false;
  is_diretor: boolean = false;

  itens: any[] = [];
  carregando: boolean = false;

  opcoesSubsegmento2: string[] = [];

  mostrarModal: boolean = false;
  editando: boolean = false;
  salvando: boolean = false;

  form: any = this.formVazio();

  constructor(
    private freteService: OrderFreteService,
    private clienteService: ClienteService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.is_master  = localStorage.getItem('is_master')  === 'true';
    this.is_diretor = localStorage.getItem('is_diretor') === 'true';
    if (this.is_master || this.is_diretor) {
      this.carregar();
      this.carregarFiltros();
    }
  }

  carregarFiltros() {
    this.clienteService.getClienteFiltrosConfigurados().subscribe(res => {
      const f = (res.filtros || []).find((f: any) => f.campo === 'subsegmento2');
      this.opcoesSubsegmento2 = f ? (f.opcoes || []) : [];
    });
  }

  carregar() {
    this.carregando = true;
    this.freteService.getAll().subscribe(res => {
      this.carregando = false;
      this.itens = res || [];
    });
  }

  abrirNovo() {
    this.editando = false;
    this.form = this.formVazio();
    this.mostrarModal = true;
  }

  abrirEditar(item: any) {
    this.editando = true;
    this.form = {
      id:                  item.id,
      valor_minimo:        item.valor_minimo,
      valor_maximo:        item.valor_maximo != null ? item.valor_maximo : '',
      frete:               item.frete,
      client_subsegmento2: item.client_subsegmento2 || ''
    };
    this.mostrarModal = true;
  }

  fecharModal() {
    this.mostrarModal = false;
  }

  salvar() {
    if (this.form.valor_minimo === null || this.form.valor_minimo === '') {
      this.toastr.warning('Informe o valor mínimo.');
      return;
    }
    if (this.form.frete === null || this.form.frete === '') {
      this.toastr.warning('Informe o valor do frete.');
      return;
    }

    const payload: any = {
      valor_minimo:        Number(this.form.valor_minimo),
      valor_maximo:        this.form.valor_maximo !== '' && this.form.valor_maximo != null
                            ? Number(this.form.valor_maximo)
                            : null,
      frete:               Number(this.form.frete),
      client_subsegmento2: this.form.client_subsegmento2.trim() || null
    };

    this.salvando = true;
    const req = this.editando
      ? this.freteService.update(this.form.id, payload)
      : this.freteService.create(payload);

    req.subscribe({
      next: () => {
        this.salvando = false;
        this.toastr.success('Salvo com sucesso.');
        this.mostrarModal = false;
        this.carregar();
      },
      error: err => {
        this.salvando = false;
        const msg = err.error || 'Erro ao salvar.';
        this.toastr.error(typeof msg === 'string' ? msg : 'Erro ao salvar.');
      }
    });
  }

  excluir(item: any) {
    if (!confirm(`Excluir faixa de R$ ${item.valor_minimo} a ${item.valor_maximo != null ? 'R$ ' + item.valor_maximo : '∞'}?`)) return;
    this.freteService.delete(item.id).subscribe({
      next: () => { this.toastr.success('Excluído.'); this.carregar(); },
      error: () => this.toastr.error('Erro ao excluir.')
    });
  }

  get label(): string {
    return this.editando ? 'Editar Faixa' : 'Nova Faixa';
  }

  private formVazio() {
    return { id: null, valor_minimo: '', valor_maximo: '', frete: '', client_subsegmento2: '' };
  }
}
